<template>
  <div class="postIndex">
    <div class="topContent clearfix">
      <div class="title text_center fl f_22 pr cursor_p color_40 font_w_b current">全部职位<span class="color_90 f_14">（在线职位: {{publishNumber}}）</span></div>
      <div class="create-container fr f_14 text_center transition_2">
        <!--广告二维码-->
        <div class="adv">
          <span>✨</span>
          <span class="adv-tips cursor_p">定制 {{moment().format('YYYY')}} 专属校招方案</span>
          <div class="adv-container">
            <div class="title-container">
              <span class="iconfont iconshouquandanchuang-weixin" />
              <div class="title-text">
                <span>扫码添加客户经理</span><br/>
                <span>定制校招方案</span>
              </div>
            </div>
            <div class="main-container">
              <img src="https://files.wondercv.com/hr/adv_wechat1.png" alt="">
              <span class="desc">客户经理kiki</span>
              <span class="tips">扫一扫上面的二维码，加我微信</span>
            </div>
          </div>
        </div>
        <div class="create cursor_p" @click="createJobs">发布职位</div>
      </div>
    </div>

    <div class="listBox">
      <skeleton :skeletonType="'jobList'" v-if="queryState && list.length == 0"></skeleton>
      <div class="list" v-if="list.length">
        <div class="flex-c-b item cursor_p" :style="{height: item.status=='publish' ? '159px' : '94px'}" v-for="(item,index) in list" :key="String(index)" @click="toJobsEdit(item)">
          <div class="list-item-left">
            <div>
              <div class="jobTitle f_18 color_40 font_w_b" :class="item.status!=='publish' ? 'color_90' : ''">
                {{item.job_post}}
<!--                <img class="pr hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="">-->
                <span class="pr color_9c f_12 tips" v-if="item.status!=='draft' && item.status!=='publish'">过期</span>
                <span class="pr color_red f_12 tips" v-else-if="item.direct_interview && item.status!=='draft'">直面</span>
                <div class="share cursor_p share-box" v-if="item.status!=='draft'">
                  分享
                  <div class="share-job-box">
                    <div class="share-header">
                      <i class="iconfont iconqiepian"></i>
                      <span>微信扫码分享职位</span>
                    </div>
                    <qrcode-vue :value="`${origin}/jobs/${item.token}.html`" :size="175"/>
                  </div>
                </div>
                 <img class="pr hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="" v-if="hotJobs[item.profession_id]">
              </div>

              <div class="jobText f_14 color_90 beforeText min-width">
                <!-- 北京 | 3-5年 | 本科 | 全职 | 20-24k -->
                <span>{{item.city || '工作地点不限'}}</span>

                <!-- 全职 -->
                <span v-if="item.job_nature === '全职'">
                  {{ !item.experience || item.experience=== '不限' ? '经验不限' : (item.experience=== '1年以下' ? '1年以内' : item.experience) }}
                </span>
                <!-- 实习 -->
                <span v-else-if="item.job_nature === '实习' && item.intern_frequency && item.intern_duration">
                  {{ `${item.intern_frequency}天/周·${item.intern_duration}` }}
                </span>
                <!-- 校招 -->
                <span v-else-if="item.job_nature === '校招' && item.graduate_times && item.graduate_times.length">
                  {{ item.graduate_times | formatGraduationYear }}
                </span>
                <span>{{item.degree || '学历不限'}}</span>
                <span v-if="item.job_nature">{{item.job_nature}}</span>
                <span v-if="item.salary">
                  {{(item.annual_month_salary && item.annual_month_salary > 12) ? `${item.salary} · ${item.annual_month_salary}薪` : item.salary}}
                </span>
                <span v-else>
                  面议
                </span>
                <span v-if="item.status!=='draft'">
                  {{(item.status === 'publish' && item.end_at) ? `到期时间：${item.end_at}` : `发布时间：${item.checkTime}`}}
                </span>
              </div>

            </div>
            <div v-if="item.status=='publish'" class="recommend" @click.stop="toRecommend(item)"><img src="https://files.wondercv.com/APP/cveditor/hrheadportrait.png"> 该职位有 99+ 个高质量推荐候选人，立即点击查看 ＞＞</div>
<!--            <div class="time f_14 color_90">-->
<!--              <template v-if="item.status==='publish'">发布于：{{item.checkTime}}</template>-->
<!--              <template v-else-if="item.status==='expired'">{{item.checkTime}} 下线</template>-->
<!--              <template v-else>{{item.updated_at | formatDate}}</template>-->
<!--            </div>-->
          </div>
          <div class="function pr">
              <div class="pa guide" style="z-index: 2" :class="[jobGuideIndex === 1 ? 'job-guide-1' : '']" v-if="index === directInterviewIndex && jobGuideIndex > -1 && jobGuideIndex < 2 && !item.direct_interview && item.status==='publish'" @click.stop>{{jobGuideText[jobGuideIndex]}} <span @click="handleClickKnow">我知道了</span></div>
<!--              <div class="button fr color_9c_hover cursor_p transition_2" @click.stop="deleteJobs(item)" v-if="item.status==='draft'">删除</div>-->
              <template v-if="item.status==='publish'">

                <!-- 刷新职位时间 -->
                <div data-growing-container :data-growing-idx="200" class="refresh-btn fr cursor_p transition_2" @click.stop="toRefresh(item)">
                  <i class="iconfont iconshuaxin"></i>
                  <span>刷新</span>
                </div>

                <!-- 精准曝光 -->
                <div data-growing-container :data-growing-idx="index"  @click.stop="showPayDialogOrReturn(item,index)" class="toSearch color_blue f_13 text_center fr transition_2 btn_w_100 border_grey" :class="[item.top_status == 1 || (item.top_status == 3 && Object.keys(item.job_condition).length == 0) ? 'active' : '']" >
                  <i class="iconfont iconzhiding"></i>
                  <span v-if="item.top_status === 1 || (item.top_status === 3 && Object.keys(item.job_condition).length == 0)">精准曝光</span>
                  <span v-if="item.top_status === 2">预约曝光</span>
                  <!-- 可能存在 item.top_status == 3 但是没有曝光条件的情况 -->
                  <span v-if="item.top_status === 3 && Object.keys(item.job_condition).length > 0">曝光中...</span>
                  <div class="edit-show" v-if="item.top_status === 3 && !mixPayDialogVisible  && Object.keys(item.job_condition).length > 0">
                    <template v-if="!!item.job_condition">
                      <div class="edit-show-item color_40">
                        <span class="color_9c">曝光职位：</span>
                        {{item.job_post}}
                      </div>
                      <div class="edit-show-item color_40">
                        <span class="color_9c">曝光时间：</span>
                        {{calcTime(item.job_condition.start_time,item.job_condition.expired_time)}}
                      </div>
                      <div class="edit-show-item color_40">
                        <span class="color_9c">学历/经验：</span>
                        <span v-if="item.job_nature == '校招'">{{schooljob(item.job_condition)}}</span>
                        <span v-else>{{[item.job_condition.degree_name,item.job_condition.experience].filter(item => !!item).join(',') || '不限'}}</span>
                      </div>
                      <div class="edit-show-item color_40">
                        <span class="color_9c">院校要求：</span>
                        {{[...item.job_condition.tag_names,...item.job_condition.edu_names.map(item=>item._root)].join(',') || '不限'}}
                      </div>
                      <div class="edit-show-item color_40">
                        <span class="color_9c">专业要求：</span>
                         {{item.job_condition.major_l1s.map(item=>item.name).join(',') || '不限'}}
                      </div>
                    </template>
                    <div class="line"></div>
                    <div class="edit-show-btns">
                      <p @click.stop="showEditDialog(item, index)" >修改曝光条件</p>
                      <p @click.stop="showPayDialog(item, index)" >续费曝光时长</p>
                    </div>
                  </div>
                </div>
                <!-- 搜简历 -->
                <div class="search-resume-btn cursor_p transition_2" @click.stop="toSearch(item)">
                  <i class="iconfont iconsousuo"></i> 搜简历
                </div>
                <!-- 操作按钮集合 -->
                <div class="operate-btn transition_2">...
                  <div class="operate-list-body transition_2">
                    <div class="operate-list-item" @click.stop="$router.push({path:`/talent/interview/${item.token}`, query: {type: item.direct_interview ? 'set' : 'create'}})">
                      {{item.direct_interview ? '约面设置' : '升级直面'}}
                    </div>
                    <div class="operate-list-item cursor_p " @click.stop="$router.push({path:`/talent/jobedit/${item.token}`})">编辑</div>
                    <div class="operate-list-item cursor_p" @click.stop="offlineJobs(item)">关闭</div>
                  </div>
                </div>
                <!-- 去设置约面时间页 -->
                <!-- <div class="interview_setting fr transition_2 cursor_p"
                  @click.stop="$router.push({path:`/talent/interview/${item.token}`, query: {type: item.direct_interview ? 'set' : 'create'}})"
                >{{item.direct_interview ? '约面设置' : '升级直面'}}</div> -->

                <!-- 去人才搜索页 -->
                <!-- <div :class="{'color_blue': item.top_status !== 1}" class="button fr color_9c_hover cursor_p transition_2 flex-c-content" @click.stop="toSearch(item)">搜简历</div> -->
                <!-- 去人才推荐页 -->
                <!-- <div class="hover_f64 button fr color_no_hover cursor_p transition_2 flex-c-content" @click.stop="toRecommend(item)">看推荐</div> -->

              </template>
              <div v-else-if="item.status==='offline' || item.status==='expired'"  class="button fr color_no_hover cursor_p transition_2" @click.stop="$router.push({path:`/talent/jobedit/${item.token}`})">重新发布</div>
              <div v-else-if="item.status==='draft'" class="draft-box flex-c-content">
                <p class="flex-c-content">「700W 候选人」期待您发布该职位 <i class="iconfont iconshouzhi"></i></p>
                <div class="cursor_p" @click.stop="toHotPublish(item)">立即发布</div>
              </div>

          </div>
        </div>
      </div>
      <template v-if="!queryState && !list.length">
        <div class="talent_notfound bg_fff text_center">
          <img src="https://files.wondercv.com/searchResume_pc/talent_notfound.png" alt="">
          <p class="f_16 color_60">暂无职位</p>
        </div>
      </template>
    </div>

    <!-- 弹出提示框 -->
    <tips-block v-if="tipsShowState" :tipsState="tipsState" :tipsType="tipsType" @hideTipsF="hideTips" @confirmButtonF="confirmButtonF" />

    <!-- 一键邀约 -->
    <invitation :jobToken='jobToken' v-if="!!jobToken" @closeInvitaion="closeInvitaion" />

    <!-- 精准曝光支付弹窗 -->
    <job-pay-dialog v-if="payDialogVisible"
                    type="top"
                    payType="bJobTop"
                    title="精准曝光"
                    subtitle=""
                    tipsText="该类产品为数字化商业产品，一经售出不支持退款退货<br />为不影响推荐效果，购买后不建议更换职位类别"
                    :jobArr="list"
                    :jobIndex="nowTopJobIndex"
                    :orderToken="orderToken"
                    :orderPriceText="199"
                    @paidFunc="paidFunc"
                    @closeFunc="closeFunc" />
    <!-- 获取刷新职位次数 -->
    <refreshPayDialog v-if="jobRefreshDialogVisible"
                    type="refresh"
                    payType="bJobRefresh"
                    title="职位刷新"
                    subtitle="刷新后可大大增加职位曝光度，候选人更容易"
                    :orderPriceText="50"
                    @paidFunc="()=>{ jobRefreshDialogVisible = false }"
                    @closeFunc="closeFunc" />
    <!-- 精准曝光火爆职位组合购买 -->
    <mix-job-pay v-if="mixPayDialogVisible"
          :jobTitle="mixJobTitle"
          :jobToken="mixJobToken"
          :job_nature="mixJobNature"
          :subtitle="mixJobEndTime"
          :nowOrderToken="mixOrderToken"
          :fromList="true"
          :endTime="hotJobEndTime"
          :formData="formData"
          @paidFunc="paidFunc"
          @closeFunc="closeFunc"
    >


    </mix-job-pay>
    <editPayDialog v-if="editDialogVisibile === true"
      type="top"
      payType="bJobTop"
      title="修改曝光条件"
      subtitle=""
      tipsText=""
      :jobArr="list"
      :jobIndex="nowTopJobIndex"
      @paidFunc="paidFuncEdit"
      @closeFunc="closeFuncEdit"
    />
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations } from 'vuex'
import { getCookieValue, get_tUser, toLogin } from '@/utils/utils'
import  hotJobPro  from '@/assets/js/constant.js'
import TipsBlock from '../components/TipsBlock';
import invitation from './components/invitation';
import jobPayDialog from '@/components/block/RecommandPay.vue'
import refreshPayDialog from '@/components/block/JobPayDialog.vue'
import editPayDialog from '@/components/block/EditShowCondition.vue'
import mixJobPay from '@/components/block/mixJobPay'
import skeleton from '@/components/skeletonDiagram/index.vue'
import moment from 'moment'
import qrcodeVue from 'qrcode-vue'

export default {
  name: 'JobLIst',
  data(){
    return {
      formData:{},
      editDialogVisibile:false,
      moment,
      tabIndex:0,
      list:[],
      queryState:true,

      userToken:'',
      userJWT:{},
      query:{
        status:'publish', //draft草稿列表  publish在线职位
        page:1,
        size:10,
      },
      status:'',//页面接口类型
      publishNumber:0, //已发布职位数量

      tipsShowState:false,//是否展示提示框
      tipsType:1, //1：只有我知道了，2：取消/确认
      tipsState:1, //提示文案样式
      tipsItem:{}, //提示时判断的数据
      jobType:{
        '大专':'专科,本科,硕士,博士,MBA',
        '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },
      jobToken: '',

      hotJobs: hotJobPro.hotJobProfessionIds,
      payDialogVisible: false, // 是否显示支付弹窗
      orderToken: null, // 订单 token
      nowTopJobIndex: null ,// 当前点击曝光的职位 在 list 里的索引
      directInterviewIndex: -1,//第一个非直面职位下标
      jobGuideIndex: 0,//引导下标
      jobGuideText:['设置精准曝光，登顶同类职位榜首，增强职位曝光','【升级直面】：可设置面试时间、初面问题'],
      origin: '',
      endTimeCount: 0, // 火爆职位距离结束的天数
      ishotJob: true,  // 是否是火爆职位
      mixPayDialogVisible: false, // 火爆职位加精准曝光组合弹框
      mixJobToken: '',
      mixJobNature:'',
      mixJobTitle: '',
      mixJobEndTime: '',
      mixOrderToken: '',
      hotJobEndTime: '', // 火爆职位截止日期
      firstCome: true, // 首次调用getlist方法
      noMore: false,  // 没有更多了
      scrollTopNumber: '',
      jobRefreshDialogVisible: false // 职位刷新弹框

    }
  },
  computed:{
    ...mapState('block',['userInfoState','bodyClientHeight', 'windowScrollTop', 'windowInnerHeight'])
  },
  components:{
    'tips-block':TipsBlock,
    invitation,
    jobPayDialog,
    qrcodeVue,
    mixJobPay,
    skeleton,
    editPayDialog,
    refreshPayDialog
  },
  watch:{
    // windowScrollTop(val, oldVal){
    //   // 重新获取body高度
    //   this.getBodyClient()
    //   // // body高度 - 浏览器窗口高度
    //   let maxScrollTop = this.bodyClientHeight - this.windowInnerHeight;
    //   // console.log(this.windowInnerHeight,val,val - maxScrollTop > -80);
    //   // if(this.noMore) return
    //   // if( val - maxScrollTop > -150 && !this.queryState) {
    //   //   this.getList()
    //   // }
    // },
  },
  async created(){
    this.jobGuideIndex = window.localStorage.getItem("job-guide") ? -1 : 0
    this.userJWT = get_tUser();
    let { status='', token='' } = this.$route.query;
    if(status==='draft'){
      this.tabIndex = 1;
      this.query.status = 'draft';
    }
    //是hr
    if(this.userJWT.h_t){
      this.getList();
      //如果有token显示一键邀约
      this.jobToken = token;
    }

    const { origin } = this.$route.query

    if (origin === 'delivery') {

      try {
        let onlineJobLength = 0
        let res = await actions.resume_permissions.recruitment()
        if (res.code === 1000) {
          if (res.data.recruit_infos) {
            onlineJobLength = res.data.recruit_infos.length
          } else {
            onlineJobLength = 0
          }
        }
        if (onlineJobLength) {
          setTimeout(() => {
            this.showPayDialog(this.list[0], 0)
          }, 1000)
        } else {
          this.$message({
            message: '发布在线职位后即可购买精准曝光服务',
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      }

    }

  },
  mounted(){
    let { origin, pathname} = window.location
    this.origin = origin
    history.replaceState(null, null, `${origin}${pathname}`)
  },
  methods:{
    ...mapMutations('block',['updagreBodyClient']),
    //获取body高度
    getBodyClient(){
      this.updagreBodyClient(document.body.clientHeight);
    },
    toRecommend(item) {
      this.$router.push({
        name:`talentRecommend`,
        query: {
          // 职位 token
          token: item.token
        }
      })
    },
    toHotPublish (item) {
      this.$router.push({
        name:`talentJobEdit`,
        params: {
          // 职位 token
          token: item.token,
          // 点击了 为火爆职位的额草稿职位 立即发布按钮，这种情况下，监听上次创建的订单，而不是再重新创建订单
          hotPublish: true,
          orderToken: item.job_order_token || null,
        }
      })
    },
    // 设置校招时间
    schooljob(data) {
      let tempArr = data?.end_at_list?.map(item => {return String(item).substr(2) + '届' }).join('、')
      return data.degree_name + (data.degree_name ? ',' : '') + tempArr + '应届生'
    },
    // 计算曝光时间
    calcTime(start,end) {
      return this.moment(start).format('MM月DD日') + '-' + this.moment(end).format('MM月DD日')
    },
    // 显示修改弹窗
    showEditDialog(data,index){
      this.mixJobToken = data.token
      this.mixJobTitle = data.job_post
      this.mixJobNature = data.job_nature
      this.formData = data
      this.nowTopJobIndex = index
      this.editDialogVisibile = true
      console.log( this.editDialogVisibile )
    },
    //是否显示支付弹窗
    showPayDialogOrReturn(data,index){
      if(data.top_status === 3) return
      this.showPayDialog(data, index)
    },
    // 显示支付弹窗
    async showPayDialog (data, index) {
      // this.moment(data.end_at)
      this.endTimeCount = (new Date(data.end_at).valueOf() - new Date(this.moment().format('YYYY-MM-DD')).valueOf()) / (1000 * 60 * 60 * 24)
      // this.ishotJob = this.hotJobs[data.profession_id]
      this.ishotJob = true
      if(this.ishotJob && this.endTimeCount < 7) {
        this.mixJobToken = data.token
        this.hotJobEndTime = data.end_at
        this.mixJobNature = data.job_nature
        this.mixJobEndTime = data.job_nature === '校招' ? '有效期:' + data.start_at + '至' + data.deadline : '有效期:' + data.end_at + '至' + this.moment(data.end_at).add(29, 'd').format('YYYY-MM-DD')
        this.mixJobTitle = data.job_post
        await this.createHotOrder(data)
        this.mixPayDialogVisible = true
        return
      }
      // 创建精准曝光订单
      this.createOrder(data.token)
      // 显示弹窗
      this.payDialogVisible = true
      // 为了支付弹窗选中第一个值
      this.nowTopJobIndex = index
    },
    // 创建精准曝光订单
    async createOrder (token) {
      try {
        let params = {
          plan: 'top',
          job_token: token,
          start_time: this.moment().format('YYYY-MM-DD')
        }
        let res = await actions.recruit_infos.create_order(params)
        if (res.code === 1000) {
          // 获取订单 token
          this.orderToken = res.data.order_token
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 创建火爆职位订单
    createHotOrder (data) {
      return new Promise(async (resolve,reject) => {
        try {
          let params = {
            plan: 'hot',
            job_token: data.token,
            hot_start_time: this.moment(data.end_at).format('YYYY-MM-DD')
          }
          let res = await actions.recruit_infos.create_order(params)
            if (res.code === 1000) {
              // 获取订单 token
              this.mixOrderToken = res.data.order_token
            }
            resolve(res)
          } catch (e) {
            console.log(e)
            reject(e)
          }
      })
    },
    // 支付成功的回调
    paidFunc () {
      this.payDialogVisible = false
      this.mixPayDialogVisible = false
      this.$message({
        message: '支付成功',
        type: 'success'
      })
      // 更新列表
      this.getList()
    },
    paidFuncEdit(){
      console.log('保存成功');
    },
    closeFuncEdit(type){
      this.editDialogVisibile = false
      if(type == 'editSuccess') {
        this.getList()
      }
    },
    // 关闭支付弹窗的回调
    closeFunc () {
      this.payDialogVisible = false
      this.mixPayDialogVisible = false
      this.jobRefreshDialogVisible = false
    },
    toggleType(tabIndex){
      this.tabIndex = tabIndex;
      let status = tabIndex===0 ? 'publish' : 'draft';
      this.query.status = status
      this.getList();
    },
    async getList(){
      this.queryState = true;
      let res = await actions.recruit_infos.get_recruit_infos_list(this.query);
      this.queryState = false;
      if(res.code===1000){
        // if(this.noMore) return
        res.data.jobs && res.data.jobs.forEach(item=>{
          item.checkTime = item.updated_at.substring(0,10)
        })
        // this.list = this.list.concat(res.data.jobs);
        this.list = res.data.jobs
        // this.noMore = this.query.page + 1 > Math.ceil(res.data.total_count/ this.query.size)
        // this.query.page = this.query.page + 1
        if(this.list.length >100 && this.list.some(item => item.direct_interview)){
          window.localStorage.setItem("job-guide", true)
        }
        this.directInterviewIndex = this.list.every(item => !item.direct_interview) ? this.list.findIndex(item => !item.direct_interview && item.status != 'offline' && item.status != 'expired') : -1
        this.publishNumber = res.data.online_jobs_count || 0
        // 从道具页进来弹第一个职位的精准曝光弹框
        if(this.$route.query && this.$route.query.fromProps && this.firstCome) {
          this.showPayDialog(this.list[0],0)
        }
      }
    },
    //去职位详情，b/c端
    toJobsEdit(item){
      // window.location.href = `/recruit_infos/${item.token}?navbar=hire`
      this.$router.push({path:`/talent/joblist/${item.token}`,query: {priority: item.priority}})
    },
    //去职位详情
    createJobs(){
      if(this.publishNumber>=150){
        this.tipsShowState = true;
        this.tipsType = 1;
        this.tipsState = 2;
        return false;
      }
      this.$router.push({path:'/talent/jobedit/create'})
    },
    //去搜简历
    toSearch(item){
      let { job_post, degree, experience, city, id } = item;
      let query = {
        keyword: job_post,
        city: city||'',
        education: degree ? (degree==='学历不限' ? '' : this.jobType[degree])  : '',
        workYear: experience ? (experience==='经验不限' ? '' : (experience==='1年以下' ? '应届生' : experience) )  : '',
        job_id: id
      }
      this.$router.push({name:'talentSearchList',query})
    },
    // 更新职位状态
    async toRefresh(item) {
      try {
        let res = await actions.recruit_infos.put_refresh('refresh', item.token)
        if (res.code === 1000) {
          // item.end_at = moment().add(29, 'd').format('YYYY-MM-DD')
          this.$message({
            // message: '刷新成功，职位有效期已延长至30天',
            message: '职位已刷新，将获得更多曝光',
            type: 'success'
          })
        } else if(res.code === 9014) {
          this.$message({
            message: '火爆职位无法刷新有效期',
            type: 'warning'
          })
        } else if(res.code === 203001) {
          this.jobRefreshDialogVisible = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    //隐藏提示
    hideTips(){
      this.tipsShowState = false;
      this.tipsItem = {};
    },
    //下线职位
    offlineJobs(item){
      this.tipsShowState = true;
      this.tipsType = 2;
      if (item.top_status === 1) {
        this.tipsState = 1;
      } else {
        this.tipsState = 3;
      }
      this.tipsItem = item;
    },
    //删除职位
    deleteJobs(item){
      this.tipsShowState = true;
      this.tipsType = 2;
      this.tipsState = 2;
      this.tipsItem = item;
    },
    //发布职位
    async publishJobs(item){
      if(this.publishNumber>=150){
        this.tipsShowState = true;
        this.tipsType = 1;
        this.tipsState = 2;
        return false;
      }
      let res = await actions.recruit_infos.put_recruit_status({
        status:'publish',
        token:item.token
        });
      if(res.code === 1000){
        this.$message({
          message: '职位发布成功',
          type: 'success'
        });
        // 关闭弹窗
        this.hideTips();
        //重新获取列表数据
        this.getList();
      }else{
        if(res.code === 9000){
          // 超出数量限制
          this.tipsState = 2;
          this.tipsShowState = true;
          return false;
        }else if(res.code === 9001){
          // 重复职位
          this.tipsState = 3;
          this.tipsShowState = true;
          return false;
        }else if(res.code === 9002){
          // 信息不全
          this.$router.push({path:`/talent/jobedit/${item.token}?tipsState=1&tipsShowState=true`})
          return false;
        }
        //出错
        this.$message({
          message: res.message,
          type: 'error'
        });
      }
    },
    //点击确定按钮
    async confirmButtonF(){
      if(this.tipsType !== 2){
        return false;
      }
      if(this.tipsState === 1 || this.tipsState === 3){
        let res = await actions.recruit_infos.put_recruit_status({
          status:'offline',
          token:this.tipsItem.token
          });
        if(res.code === 1000){
          this.$message({
            message: '职位关闭成功',
            type: 'success'
          });
          // 关闭弹窗
          this.hideTips();
          //重新获取列表数据
          this.getList();
        }else{
          //出错
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }else if(this.tipsState === 2){
        let res = await actions.recruit_infos.delete_recruit(this.tipsItem.token);
        if(res.code === 1000){
          this.$message({
            message: '草稿职位删除成功',
            type: 'success'
          });
          // 关闭弹窗
          this.hideTips();
          //重新获取列表数据
          this.getList();
        }else{
          //出错
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }
    },
    //关闭一键邀约
    closeInvitaion(){
      this.jobToken = '';
    },
    handleClickKnow(){
      this.jobGuideIndex++;
      window.localStorage.setItem("job-guide", true)
    }
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
    },
    formatGraduationYear (yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('、') + '届'
    }
  }
}
</script>
<style lang="scss" scoped>
.btn_w_100 {
  width: 100px !important;
}
.btn_w_104 {
  width: 104px !important;
}

@import './Index.scss';
.share-box{
  position: relative;
  &:hover{
    .share-job-box{
      display: flex;
    }
  }
}
.share-job-box{
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 296px;
  height: 327px;
  position: absolute;
  background-image: url("https://files.wondercv.com/pc/hr/jobBg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  left: -65px;
  padding-top: 44px;
  box-sizing: border-box;
  z-index: 10;
  .share-header{
    display: flex;
    align-items: center;
    margin-bottom: 27px;
    font-size: 18px;
    font-weight: 500;
    color: #404040;
    line-height: 18px;
    .iconfont{
      font-size: 17px;
      margin-right: 7px;
      color: #46BB36;
    }
  }
  ::v-deep img{
    width: 178px;
    height: 178px;
  }

}
.min-width{
  min-width: 400px;
}
</style>
